import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Loading from '../../components/Loading/Loading';
import {Translate, I18n} from 'react-redux-i18n';

import {
  validate as validateTokenAction,
} from '../ValidateToken/ValidateTokenActions';

import style from './Help.module.css';

function Help(props) {
  const { loading, validateToken } = props;

  useEffect(() => {
    validateToken();
  }, []);

  return (
      <div className="row">
          <div className="col-md-12 mt-4">
          <h3><strong><Translate value="help.pageTitle"/></strong></h3>
          <p><Translate value="help.summary" dangerousHTML/></p>
          <hr />
          <div className={`row ${style.sectionWrapper}`}>
              <div className="col-xs-6 col-xs-offset-3 col-sm-offset-0 col-sm-4 col-md-3 col-lg-2">
              <div className={style.section}>
                  <div className={style.sectionIcon}>
                  <i className="fas fa-map" />
                  </div>
              </div>
              </div>
              <div className="col-xs-12 col-sm-8 col-md-9 col-lg-10">
              <h4><strong><Translate value="help.scenarios.title"/></strong></h4>
              <p><Translate value="help.scenarios.content" dangerousHTML/></p>
              </div>
          </div>
          <div className={`row ${style.sectionWrapper}`}>
              <div className="col-xs-6 col-xs-offset-3 col-sm-offset-0 col-sm-4 col-md-3 col-lg-2">
              <div className={style.section}>
                  <div className={style.sectionIcon}>
                  <i className="fas fa-sitemap" />
                  </div>
              </div>
              </div>
              <div className="col-xs-12 col-sm-8 col-md-9 col-lg-10">
              <h4><strong><Translate value="help.exercises.title"/></strong></h4>
              <p><Translate value="help.exercises.content" dangerousHTML/></p>
              </div>
          </div>
          <div className={`row ${style.sectionWrapper}`}>
              <div className="col-xs-6 col-xs-offset-3 col-sm-offset-0 col-sm-4 col-md-3 col-lg-2">
              <div className={style.section}>
                  <div className={style.sectionIcon}>
                  <i className="fas fa-users" />
                  </div>
              </div>
              </div>
              <div className="col-xs-12 col-sm-8 col-md-9 col-lg-10">
              <h4><strong><Translate value="help.users.title"/></strong></h4>
              <p><Translate value="help.users.content" dangerousHTML/></p>
              </div>
          </div>
          <div className={`row ${style.sectionWrapper}`}>
              <div className="col-xs-6 col-xs-offset-3 col-sm-offset-0 col-sm-4 col-md-3 col-lg-2">
              <div className={style.section}>
                  <div className={style.sectionIcon}>
                  <i className="fas fa-user-circle" />
                  </div>
              </div>
              </div>
              <div className="col-xs-12 col-sm-8 col-md-9 col-lg-10">
              <h4><strong><Translate value="help.account.title"/></strong></h4>
              <p><Translate value="help.account.content" dangerousHTML/></p>
              </div>
          </div>
          <h3 className={style.stitle}><strong><Translate value="help.faq.title"/></strong></h3>
          <hr />
          <h4 className={style.sstitle}><strong>How can I get help?</strong></h4>
          {<p>Please contact us through <a href="https://simsushare.com/contact-us/" rel="noopener noreferrer" target="_blank">visiting our main contact page</a>.</p>}
          </div>
      </div>
  );
}

Help.propTypes = {
  loading: PropTypes.bool,
  validateToken: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.validateToken.loading,
});

const mapDispatchToProps = {
  validateToken: validateTokenAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Help);

